import React, { useState } from 'react'
import classess from './Header.scss'
import Aux from '../../hoc/Auxiliary/Auxiliary'

import { withRouter } from 'react-router-dom'
import { withTranslate } from 'react-redux-multilingual'
// import { connect } from 'react-redux'

import Profile from '../../containers/Menu/Menu'
import Logo from '../Logo/Logo'
import Backdrop from '../UI/Backdrop/Backdrop'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
// import CssBaseline from '@material-ui/core/CssBaseline'
// import AppBar from '@material-ui/core/AppBar';
// import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List'
// import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
// import IconButton from '@material-ui/core/IconButton';
// import MenuIcon from '@material-ui/icons/Menu';
import HorizontalSplitIcon from '@material-ui/icons/HorizontalSplit'
import VerticalSplitIcon from '@material-ui/icons/VerticalSplit'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Collapse from '@material-ui/core/Collapse'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import HomeIcon from '@material-ui/icons/Home'
import PeopleAltIcon from '@material-ui/icons/PeopleAlt'
import FolderRoundedIcon from '@material-ui/icons/FolderRounded'
import FormatListBulletedRoundedIcon from '@material-ui/icons/FormatListBulletedRounded'
import AccountBoxIcon from '@material-ui/icons/AccountBox'
import DescriptionRoundedIcon from '@material-ui/icons/DescriptionRounded'
import Tooltip from '@material-ui/core/Tooltip'
import AssignmentIcon from '@material-ui/icons/Assignment'
import AssessmentIcon from '@material-ui/icons/Assessment'
import SettingsIcon from '@material-ui/icons/Settings'
import DnsIcon from '@material-ui/icons/Dns'
import DashboardIcon from '@material-ui/icons/Dashboard'
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn'
import { Comment, ImportExport, TableChart } from '@material-ui/icons'

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import icons from '../../icons'

const Header = props => {
  const [open, setOpen] = useState(false)

  const drawerWidth = 270
  // const bar = window.innerHeight
  const backgroundColor = '#1A90DC'

  const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex'
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    appBarShift: {
      marginLeft: 200,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    menuButton: {
      marginRight: 35
    },
    hide: {
      display: 'none'
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      backgroundColor: backgroundColor
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      }),
      backgroundColor: backgroundColor
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      overflowX: 'hidden',
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up('xl')]: {
        width: theme.spacing(9) + 1
      },
      backgroundColor: backgroundColor
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3)
    }
  }))
  const classes = useStyles()
  const theme = useTheme()
  const useStylesList = makeStyles(theme => ({
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: 'rgb(26, 144, 220)'
    },
    nested: {
      paddingLeft: theme.spacing(4)
    },
    nestedd: {
      paddingRight: theme.spacing(8)
    },
    icon: {
      color: 'white'
    }
  }))
  const navi = [
    {
      icon: <HomeIcon />,
      link: '/',
      multi: false,
      key: '',
      alwaysShow: true,
      name: 'home'
    },
    {
      icon: <PeopleAltIcon />,
      link: '/',
      open: false,
      multi: true,
      key: 'manageUser',
      name: 'manageUser',
      child: [
        { key: 'role', name: 'role', link: '/manage/role' },
        { key: 'user', name: 'users', link: '/manage/user' }
      ]
    },
    {
      icon: <FolderRoundedIcon />,
      link: '/',
      open: false,
      multi: true,
      key: 'setupData',
      name: 'setupData',
      child: [
        { key: 'criteria', name: 'appraisalCriteria', link: '/setup/criteria' },
        { key: 'company', name: 'company', link: '/setup/company' },
        { key: 'competency_score', name: 'competencyScore', link: '/setup/competency_score' },
        { key: 'form', name: 'form', link: '/setup/form' },
        { key: 'kpi_type', name: 'kpiType', link: '/setup/kpi' },
        { key: 'level', name: 'level', link: '/setup/level' },
        { key: 'level_group', name: 'levelGroup', link: '/setup/level_group' },
        { key: 'organization', name: 'organization', link: '/setup/organization' },
        { key: 'perspective', name: 'perspective', link: '/setup/perspective' },
        { key: 'position', name: 'position', link: '/setup/position' },
        { key: 'position_group', name: 'positionGroup', link: '/setup/position_group' },
        { key: 'structure', name: 'structure', link: '/setup/structure' },
        { key: 'threshold_group', name: 'thresholdGroup', link: '/setup/threshold_group' },
        { key: 'uom', name: 'uom', link: '/setup/uom' },
        { key: 'grade_criteria', name: 'gradeCriteria', link: '/setup/grade_criteria' },
        { key: 'force_rank_group', name: 'forceRankGroup', link: '/setup/force_rank_group' }
      ]
    },
    {
      icon: <AssignmentIcon />,
      link: '/appraisal_item',
      multi: false,
      key: 'item',
      name: 'appraisalItem'
    },
    {
      icon: <AccountBoxIcon />,
      link: '/employee',
      multi: false,
      key: 'employee',
      name: 'employee'
    },
    {
      icon: <AssignmentTurnedInIcon />,
      link: '/',
      multi: true,
      open: false,
      key: 'assignment',
      name: 'assignment',
      child: [
        { key: 'assignment', name: 'individual', link: '/assignment/individual' },
        { key: 'assignment', name: 'corporate', link: '/assignment/corporate' }
      ]
    },
    {
      icon: <FormatListBulletedRoundedIcon />,
      link: '/appraisal',
      multi: false,
      key: 'appraisal',
      name: 'appraisal'
    },
    {
      icon: <DashboardIcon />,
      link: '/force_rank',
      multi: false,
      key: 'force_rank',
      name: 'forceRank'
    },
    {
      icon: <VerticalSplitIcon />,
      link: '/force_rank_vertical',
      multi: false,
      key: 'force_rank_vertical',
      name: 'forceRankVertical'
    },
    {
      icon: <HorizontalSplitIcon />,
      link: '/force_rank_horizontal',
      multi: false,
      key: 'force_rank_horizontal',
      name: 'forceRankHorizontal'
    },
    {
      icon: <HorizontalSplitIcon />,
      link: '/force_rank_horizontal_board',
      multi: false,
      key: 'force_rank_horizontal_board',
      name: 'forceRankHorizontalBoard'
    },
    {
      icon: <ImportExport />,
      link: '/import_salary',
      multi: false,
      key: 'import_salary',
      name: 'importSalary'
    },
    {
      icon: <AssessmentIcon />,
      link: '/',
      multi: true,
      open: false,
      key: 'dashboard',
      name: 'dashboard',
      child: [
        {
          key: 'dashboard_branch_performance',
          name: 'dashboardBranchPerformance',
          link: '/dashboard/branch_performance'
        },
        {
          key: 'dashboard_overall_performance',
          name: 'dashboardOverallPerformance',
          link: '/dashboard/overall_performance'
        },
        {
          key: 'dashboard_performance_comparison',
          name: 'dashboardPerformanceComparison',
          link: '/dashboard/performance_comparison'
        },
        {
          key: 'dashboard_performance_trend',
          name: 'dashboardPerformanceTrend',
          link: '/dashboard/dashboard_performance_trend'
        }
      ]
    },
    {
      icon: <DescriptionRoundedIcon />,
      link: '/',
      multi: true,
      open: false,
      key: 'report',
      name: 'report',
      child: [
        { key: 'report_appraisal', name: 'reportAppraisal', link: '/report/appraisal' },
        {
          key: 'report_appraisal_by_org',
          name: 'reportAppraisalByOrg',
          link: '/report/appraisalbyorg'
        },
        {
          key: 'report_appraisal_by_level',
          name: 'reportAppraisalByLevel',
          link: '/report/appraisalbylevel'
        },
        {
          key: 'report_appraisal_by_job_kpi',
          name: 'reportAppraisalByJobKpi',
          link: '/report/appraisalbyjobkpi'
        },
        { key: 'report_data_entry', name: 'reportDataEntry', link: '/report/data_entry' },
        { key: 'report_kpi', name: 'reportKpi', link: '/report/kpi' },
        {
          key: 'report_performance_form',
          name: 'reportPerformanceForm',
          link: '/report/performance_form'
        },
        { key: 'report_bonus_salary', name: 'reportBonusSalary', link: '/report/bonussalary' },
        { key: 'usage_log', name: 'usageLog', link: '/report/usage_log' }
      ]
    },
    {
      icon: <SettingsIcon />,
      link: '/',
      multi: true,
      open: false,
      key: 'setting',
      name: 'setting',
      child: [
        { key: 'password_policy', name: 'passwordPolicy', link: '/setting/password_policy' },
        { key: 'ldap', name: 'ldap', link: '/setting/LDAP' },
        { key: 'e_mail_server', name: 'eMailServer', link: '/setting/e_mail_server' }
      ]
    },
    {
      icon: <DnsIcon />,
      link: '/',
      multi: false,
      key: 'appraisalCriteria',
      name: 'dataIntegration'
    },
    {
      icon: <Comment />,
      link: '/feedback',
      multi: false,
      key: 'feedback',
      name: 'feedback'
    },
    {
      icon: <TableChart />,
      link: '/feedback_report',
      multi: false,
      key: 'feedback_report',
      name: 'feedbackReport'
    }
  ]
  const classesList = useStylesList()
  let [navigation, setNav] = React.useState([...navi])
  const handleDrawerOpen = () => {
    setOpen(true)
  }

  const handleDrawerClose = () => {
    navigation = navigation.map(nav => {
      return {
        ...nav,
        open: false
      }
    })
    setNav(navigation)
    setOpen(false)
  }

  const handleClick = item => {
    navigation = navigation.map(nav => {
      if (nav.name === item.name) {
        return {
          ...item,
          open: !item.open
        }
      } else {
        return {
          ...nav,
          open: false
        }
      }
    })
    setNav(navigation)
    handleDrawerOpen()
  }
  const permission = JSON.parse(localStorage.getItem('userPermissions'))
  const itemMulti = item => {
    let check = false
    item.child.map(child => {
      if ((permission ?? []).find(per => per.url === child.key && per.is_view === 1)) {
        check = true
      }
      return child
    })

    if (check) {
      return (
        <Aux key={item.name}>
          <ListItem button onClick={() => handleClick(item)}>
            {!open ? (
              <Tooltip title={props.translate(item.name)} placement='right'>
                <ListItemIcon className={classesList.icon}>{item.icon}</ListItemIcon>
              </Tooltip>
            ) : (
              <ListItemIcon className={classesList.icon}>{item.icon}</ListItemIcon>
            )}
            <ListItemText className={classesList.icon} primary={props.translate(item.name)} />
            {item.open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={item.open} timeout='auto' unmountOnExit>
            <List component='div' disablePadding>
              {item.child.map(list => itemList(list))}
            </List>
          </Collapse>
        </Aux>
      )
    } else {
      return null
    }
  }

  const itemList = list => {
    let check = (permission ?? []).find(per => per.url === list.key && per.is_view === 1)

    if (check) {
      return (
        <Link key={list.name} to={list.link} style={{ textDecoration: 'none', color: 'white' }}>
          <ListItem button className={classesList.nested} onClick={() => handleDrawerClose()}>
            <ListItemText
              primaryTypographyProps={{ variant: 'subtitle2' }}
              primary={props.translate(list.name)}
            />
          </ListItem>
        </Link>
      )
    } else {
      return null
    }
  }

  const listNode = item => {
    let check = (permission ?? []).find(per => per.url === item.key && per.is_view === 1)
    if (check || item.alwaysShow) {
      return (
        <Link key={item.name} to={item.link} style={{ textDecoration: 'none', color: 'white' }}>
          <ListItem button onClick={() => handleDrawerClose()}>
            {!open ? (
              <Tooltip title={props.translate(item.name)} placement='right'>
                <ListItemIcon className={classesList.icon}>{item.icon}</ListItemIcon>
              </Tooltip>
            ) : (
              <ListItemIcon className={classesList.icon}>{item.icon}</ListItemIcon>
            )}
            <ListItemText primary={props.translate(item.name)} />
          </ListItem>
        </Link>
      )
    } else {
      return null
    }
  }

  return (
    <div className={classess.Header}>
      <AppBar
        position='fixed'
        color={'inherit'}
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open
        })}>
        <Toolbar>
          <IconButton
            onClick={() => handleDrawerOpen()}
            edge='start'
            className={classess.menuButton}
            color='primary'
            aria-label='menu'>
            <MenuIcon />
          </IconButton>
          <div className={classess.Title}>
            <div className={classess.Logo}>
              <Logo />
            </div>
          </div>
          <Profile />
        </Toolbar>
      </AppBar>
      <Backdrop show={open} clicked={() => handleDrawerClose()}></Backdrop>
      <Drawer
        variant='permanent'
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open
          })
        }}>
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </div>
        <Divider />
        {/* <List className={classesList.root}>
          <ListItem onClick={() => handleDrawerOpen()} button className={classesList.nestedd}>
            <ListItemIcon>
              <MenuIcon color={'primary'} />
            </ListItemIcon>
          </ListItem>
        </List> */}
        <List component='nav' aria-labelledby='nested-list-subheader' className={classesList.root}>
          {navigation.map(item => {
            if (item.multi) {
              return itemMulti(item)
            } else {
              return listNode(item)
            }
          })}
        </List>
      </Drawer>
    </div>
  )
}

export default withRouter(withTranslate(Header))
